export function mode<T>(myArray: T[]): T | null {
  return myArray.reduce(
    (a, b, _i, arr) => (arr.filter(v => v === a).length >= arr.filter(v => v === b).length ? a : b),
    null,
  );
}
